import logger from '@/utils/logger';

// DATA MUTATIONS
function replaceRealms(state, payload) {
  if (Array.isArray(payload)) {
    state.realms = payload.reduce((acc, cur) => ({ ...acc, [cur.name]: cur }), {});
  }
}

function addRealm(state, payload) {
  try {
    const realm = { ...payload.realm };
    if (state.add_realm.regex.test(realm.name)) {
      state.realms[realm.name] = realm;
    }
  } catch (err) {
    logger.warn(err);
  }
}

function removeRealm(state, payload) {
  try {
    const { realms } = state;
    delete realms[payload];
  } catch (err) {
    logger.warn(err);
  }
}

function replaceRealmTags(state, payload) {
  const { name, tags } = payload;
  if (Array.isArray(tags)) {
    state.realms[name].tags = tags;
  }
}

// TAG
function addTagItems(state, payload) {
  const { items } = payload;

  if (payload.realm.name && Array.isArray(items)) {
    state.realms[state.focusedRealm].tags = [...state.realms[state.focusedRealm].tags, ...items];
  }
}
function removeTagItem(state, payload) {
  const { realm, tag } = payload;

  const match = state.realms[realm].tags;

  if (Array.isArray(match)) {
    const filtered = match.filter((t) => t.name !== tag);
    state.realms[realm].tags = filtered;
  }
}
function updateTagItem(state, payload) {
  const { realm, tag } = payload;
  const match = state.realms[realm.name].tags;

  if (Array.isArray(match)) {
    const tagName = tag.name;
    const idx = match.findIndex((t) => t.name === tagName);

    if (idx !== -1) {
      state.realms[realm.name].tags.splice(idx, 1, tag);
    }
  }
}

// UI MUTATIONS
function setRealmFocus(state, payload) {
  const { name } = payload;
  const notCurrent = state.focusedRealm !== name;

  if (notCurrent) {
    state.focusedRealm = name;
  }
}

function resetRealmFocus(state) {
  state.focusedRealm = null;
}

export default {
  addRealm,
  removeRealm,

  addTagItems,
  removeTagItem,
  updateTagItem,
  replaceRealms,
  replaceRealmTags,

  setRealmFocus,
  resetRealmFocus,
};
